module.exports = __webpack_public_path__ + "static/2-da6f8adf8373d57b35421449e999ee3c.jpg";